// tslint:disable-next-line:ter-max-len
import { isValidBusinessRegistrationNumber } from 'utils/isValidBusinessRegistrationNumber/isValidBusinessRegistrationNumber';

export const validateBusinessRegistrationNumber = (label: string) => (value: string) =>
  value && isValidBusinessRegistrationNumber(value) ? undefined : label;
